export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=3c6cd85b"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Crews/index.vue?vue&type=template&id=3c6cd85b
// module id = 2519
// module chunks = 31